import { startNumbersTool } from "./numbers-tool.js";
import { startTools } from "./start-tools.js";

/**
 * The bundle for the numbers converter.
 *
 * The smallest of the four, and the page that gained the most from there being
 * four: saying 2026 in Chinese needs the numerals and nothing else, and it used
 * to arrive with the whole character dictionary reader attached.
 *
 * It exports nothing, and that is the point — a module whose whole purpose is
 * a side effect should not also be something other modules import.
 */
startTools(document, new Map([["numbers", startNumbersTool]]));
